<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
  <div class="flex-header" style="position: relative;">
    <student-header [pageTitle]="pageTitle" [useStudents]="useStudents" [showYearSelector]="false">
      <div *ngIf="needToProcess" style="padding-top: 40px;">
        <span>Submitted By and On</span><br>
        <span>{{data.attendanceCheckInOut.SubmittedBy}} on {{data.attendanceCheckInOut.SubmittedOn | date: 'MM/dd/yyyy'}} at {{data.attendanceCheckInOut.SubmittedOn | date: 'h:mm a'}}</span>
      </div>
    </student-header>

    <div *ngIf="calledFromCheckInOut" style="top: 60px;position: absolute; right: 10px;">
      Step 3 of 3 - Review Changes for Each Student
    </div>

    <div *ngIf="calledAsDialog" style="top: 40px;position: absolute; right: 10px;">
      {{attendanceDate | date: 'MM/dd/yyyy'}} - {{checkInOutTime}}
    </div>

    <div *ngIf="calledAsDialog && reviewAbsentNoticeDialog" style="top: 40px;position: absolute; right: 10px;">
      {{absentNotice.StartDate | date: 'MM/dd/yyyy'}} - {{absentNotice.EndDate | date: 'MM/dd/yyyy'}}
    </div>
  </div>

  <div class="flex-content" style="height: 100%;">
    <div style="display: flex;flex-direction: row;" *ngIf="!calledAsDialog || checkInCheckOutDialog">
      <div *ngIf="!calledAsDialog" style="padding-left: 10px; width: 48%;"
        [ngClass]="{'attendanceDateChange': !sameDate}">
        <tyl-datepicker #datAttendanceDateRef id="attendanceDateRef" name="attendanceDateRef"
          (valueChange)="dateChange($event)" (dateInputChange)="datAttendanceDate = $event" [isRequired]="true"
          [(value)]="attendanceDate" style="width: 170px;" label="Attendance Date">
        </tyl-datepicker>
      </div>

      <div *ngIf="needToProcess" style="padding-top: 5px;">
        <tyl-radio-group #typeRef style="margin-left: 10px;" arrange="vertical" name="Type"
          [(selected)]="data.attendanceCheckInOut.Type" [values]="['Check In', 'Check Out']" [labels]="['Check In', 'Check Out']"
          [ids]="['checkIn', 'checkOut']">
        </tyl-radio-group>
      </div>

      <div style="display: flex;flex-direction: row;">
        <tyl-time-field #timeInput style="margin-right: 20px;width: 150px;" label="Time" id="timeInput" name="timeInput"
          width="130px" [required]="true" [(timeValue)]="checkInOutTime" (timeFieldChange)="timeField = $event"
          [showNowButton]="true"></tyl-time-field>
      </div>

      <div style="padding-left: 10px;">
        <tyl-form-field label="Periods Code" style="width: 120px;">
          <mat-select #periodCode [(ngModel)]="selectedAttendanceCode" [required]="true" name="stateReporting"
            id="stateReporting">
            <mat-option *ngFor="let item of attendanceCodes;" [value]="item.Id">
              <span>{{item.CodeDescription}}</span>
            </mat-option>
          </mat-select>
        </tyl-form-field>
      </div>

      <div *ngIf="calledAsDialog" style="padding-left: 10px;padding-top: 5px;">
        <button mat-stroked-button class="check-in-out-button" (click)="checkInOutClick('')"><span
            translate>Apply</span></button>
      </div>

      <div *ngIf="!calledAsDialog" style="padding-left: 10px;padding-top: 5px;">
        <button mat-stroked-button class="check-in-out-button" (click)="checkInOutClick('Check In')"><span
            translate>Check In</span></button>
      </div>

      <div *ngIf="!calledAsDialog" style="padding-left: 10px;padding-top: 5px;">
        <button mat-stroked-button class="check-in-out-button" (click)="checkInOutClick('Check Out')"><span
            translate>Check Out</span></button>
      </div>

      <div *ngIf="needToProcess" style="padding-left: 10px;padding-top: 5px;">
        <span>Reason</span><br>
        <span>{{data.attendanceCheckInOut.Reason}}</span>
      </div>

      <div *ngIf="!calledAsDialog" style="padding-left: 10px;padding-top: 5px;">
        <button mat-stroked-button (click)="clearChangesClick()"><span translate>Clear Changes</span></button>
      </div>
    </div>

    <div style="display: flex;flex-direction: row;" *ngIf="calledAsDialog && reviewAbsentNoticeDialog">
      <div style="padding-left: 10px; display: flex; flex-direction: column; justify-content: flex-end;">
        <tyl-datepicker #startDateRef id="startDateRef" name="startDateRef" [(value)]="startDate" style="width: 170px;" label="Start Date"  (valueChange)="reviewStartEndDatesChanged()"></tyl-datepicker>
      </div>

      <div style="padding-left: 10px; display: flex; flex-direction: column; justify-content: flex-end;">
        <tyl-datepicker #endDateRef id="endDateRef" name="endDateRef" [(value)]="endDate" style="width: 170px;" label="End Date"  (valueChange)="reviewStartEndDatesChanged()"></tyl-datepicker>
      </div>

      <div style="padding-left: 10px; display: flex; flex-direction: column; justify-content: flex-end;">
        <tyl-form-field label="Periods Code" style="width: 120px;">
          <mat-select #periodCode [(ngModel)]="selectedAttendanceCode" [required]="true" name="attendanceCode" id="ddAttendanceCode">
            <mat-option *ngFor="let item of attendanceCodes;" [value]="item.Id">
              <span>{{item.CodeDescription}}</span>
            </mat-option>
          </mat-select>
        </tyl-form-field>
      </div>

      <div style="padding-left: 10px;padding-bottom: 25px; display: flex; flex-direction: column; justify-content: flex-end;">
        <button mat-stroked-button class="check-in-out-button" (click)="applyClick()"><span
            translate>Apply</span></button>
      </div>

      <div style="padding-left: 10px;padding-bottom: 25px; display: flex; flex-direction: column; justify-content: flex-end;">
        <button mat-stroked-button (click)="clearChangesClick()"><span translate>Clear Changes</span></button>
      </div>
      
      <div style="padding-left: 30px;padding-bottom: 25px; display:flex; flex-direction: row; justify-content: flex-end; width: 100%;">
        <div style="display: flex; flex-direction: column; width: 100%; min-width: 200px;">
          <div style="display: flex; flex-direction: column; padding-bottom: 10px;">
            <div class="label">
              <span>Submitted By and On</span>
            </div>
            <span>{{absentNotice.SubmittedName}} on {{absentNotice.LastUpdated | date:'MM/dd/yy'}} at {{absentNotice.LastUpdated | date:'h:mm a'}}</span>
          </div>
          <div style="display: flex; flex-direction: column;">
            <span class="label">Reason</span>
            <span>{{absentNotice.Reason}}</span>
          </div>
        </div>
      </div>
    </div>

    <tabs [tabNames]="tabNames" (tabChange)="selectedTabChanged($event)"*ngIf="calledAsDialog && reviewAbsentNoticeDialog && tabNamesLoaded"></tabs>

    <div style="text-align:center;" *ngIf="angularMatData.data.length == 0">
      No classes exists for selected Date
    </div>

    <div *ngIf="angularMatData.data.length > 0">
      <mat-table #table [dataSource]="angularMatData">

        <!-- Meets -->
        <ng-container matColumnDef='Meets'>
          <mat-header-cell *matHeaderCellDef>Meets
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.Meets}}</mat-cell>
        </ng-container>

        <!-- Start -->
        <ng-container matColumnDef='Start'>
          <mat-header-cell *matHeaderCellDef>
            Start
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.StartTime}}</mat-cell>
        </ng-container>

        <!-- End -->
        <ng-container matColumnDef='End'>
          <mat-header-cell *matHeaderCellDef>
            End
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.EndTime}}</mat-cell>
        </ng-container>

        <!-- Code -->
        <ng-container matColumnDef='Code'>
          <mat-header-cell *matHeaderCellDef>
            Code
          </mat-header-cell>
          <mat-cell *matCellDef="let st"
            [ngClass]="{'highlightText': st.AttendanceCodeId != st.OrgAttendanceCodeId, 'highlightAttendanceType': !st.TeacherCanMark && st.AttendanceCodeId == st.OrgAttendanceCodeId}">
            <div style="width: 60px;">
              <tyl-form-field label='' style="width: 60px;" *ngIf="st.HasFocus">
                <mat-select [id]='"ddlAdminAttendanceCell" + cellIndex' [(ngModel)]='st.AttenCodeId'
                  (selectionChange)="selectedCodeChange(st, st.AttenCodeId)" [name]='"AdminAttendanceCell" + cellIndex'>
                  <mat-option *ngFor='let code of validAttendanceCode' [value]="code.Id">{{code.CodeDescription}}
                  </mat-option>
                </mat-select>
              </tyl-form-field>
              <span *ngIf="!st.HasFocus">{{st.AttendanceCode}}</span>
              <span *ngIf="st.MarkedByAdmin" class="markedByAdminIcon">A</span>
              <span *ngIf="st.PeriodicComment" class="commentIcon">C</span>
            </div>
          </mat-cell>
        </ng-container>

        <!-- Previous Code -->
        <ng-container matColumnDef='PreviousCode'>
          <mat-header-cell *matHeaderCellDef>
            Previous Code
          </mat-header-cell>
          <mat-cell *matCellDef="let st">
            <div style="width: 60px;">
              <span>{{st.OrgAttendanceCode}}</span>
              <span *ngIf="st.MarkedByAdmin" class="markedByAdminIcon">A</span>
              <span *ngIf="st.PeriodicComment" class="commentIcon">C</span>
            </div>
          </mat-cell>
        </ng-container>

        <!-- NewCode -->
        <ng-container matColumnDef='NewCode'>
          <mat-header-cell *matHeaderCellDef>
            New Code
          </mat-header-cell>
          <mat-cell *matCellDef="let st"
            [ngClass]="{'highlightText': st.AttendanceCodeId != st.OrgAttendanceCodeId, 'highlightAttendanceType': !st.TeacherCanMark && st.AttendanceCodeId == st.OrgAttendanceCodeId}">
            <div *ngIf="st.PeriodAvailable" style="width: 60px;">
              <tyl-form-field label='' style="width: 60px;">
                <mat-select [id]='"ddlAdminAttendanceCell" + cellIndex' [(ngModel)]='st.AttenCodeId'
                  (selectionChange)="selectedCodeChange(st, st.AttenCodeId)" [name]='"AdminAttendanceCell" + cellIndex'>
                  <mat-option *ngFor='let code of validAttendanceCode' [value]="code.Id">{{code.CodeDescription}}
                  </mat-option>
                </mat-select>
              </tyl-form-field>
            </div>
          </mat-cell>
        </ng-container>

        <!-- Attendnace Type -->
        <ng-container matColumnDef='Atd'>
          <mat-header-cell *matHeaderCellDef>
            Atd
          </mat-header-cell>
          <mat-cell *matCellDef="let st" [ngClass]="{'highlightAttendanceType': !st.TeacherCanMark}">
            {{st.AttendanceType}}</mat-cell>
        </ng-container>

        <!-- Minutes -->
        <ng-container matColumnDef='Minutes'>
          <mat-header-cell *matHeaderCellDef>
            Missed Minutes
          </mat-header-cell>
          <mat-cell *matCellDef="let st">
            <span *ngIf="!st.PromptForPartialMinutes || !st.HasFocus">{{st.PartialMinutesAbsence}}</span>
            <tyl-form-field *ngIf="st.PromptForPartialMinutes && st.HasFocus" style="width: 70px;">
              <input matInput id="txtOccupancy" [(ngModel)]="st.PartialMinutesAbsence" [allowDecimal]="false"
                [maxPrecision]="0" [minimumEnforce]="1" [maximumEnforce]="999" [attr.maxlength]="3" />
            </tyl-form-field>
          </mat-cell>
        </ng-container>

        <!-- Lunch -->
        <ng-container matColumnDef='Lunch'>
          <mat-header-cell *matHeaderCellDef>
            Lunch
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.Lunch}}</mat-cell>
        </ng-container>

        <!-- Term -->
        <ng-container matColumnDef='Term'>
          <mat-header-cell *matHeaderCellDef>
            Term
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.SubjectTermType}}</mat-cell>
        </ng-container>

        <!-- Course -->
        <ng-container matColumnDef='Course'>
          <mat-header-cell *matHeaderCellDef>
            Course-Section
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.SubjectSection}}</mat-cell>
        </ng-container>

        <!-- Teacher -->
        <ng-container matColumnDef='Teacher'>
          <mat-header-cell *matHeaderCellDef>
            Teacher
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.TeacherName}}</mat-cell>
        </ng-container>

        <!-- EntryDate -->
        <ng-container matColumnDef='EntryDate'>
          <mat-header-cell *matHeaderCellDef>
            Entry Date
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.EntryDate | date: 'MM/dd/yy'}}</mat-cell>
        </ng-container>

        <!-- DroppedDate -->
        <ng-container matColumnDef='DroppedDate'>
          <mat-header-cell *matHeaderCellDef>
            Dropped Date
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.DroppedDate | date: 'MM/dd/yy'}}</mat-cell>
        </ng-container>

        <!-- Comment -->
        <ng-container matColumnDef='Comment'>
          <mat-header-cell *matHeaderCellDef>
            Comment
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.PeriodicComment}}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columnsToDisplay"
          style="position:sticky;top:0;z-index:100;background:white;border-top-style: solid;border-top-color: lightgray;border-top-width: thin;padding:0px;">
        </mat-header-row>
        <mat-row *matRowDef="let row; columns: columnsToDisplay;"
          [ngClass]="row.PeriodAvailable == false ? 'disable-row' : ''"
          style="padding:0px;align-items: start;overflow: hidden;" (click)="rowClick(row)">
        </mat-row>
      </mat-table>
    </div>

    <div style="display: flex; flex-direction: row;padding-top: 10px;">
      <div *ngIf="angularMatData.data.length > 0" [ngStyle]="{'width': calledAsDialog ? '35%': '100%'}">
        <tyl-form-field label="Daily Comment" style="width:100%">
          <textarea matInput name="txtReason" Id="txtReason"
            style="resize: none;width:100%;vertical-align:top;padding-top:0px;padding-bottom:0px;"
            [(ngModel)]="dailyComment" rows="4"></textarea>
        </tyl-form-field>
      </div>

      <div *ngIf="attachmentMatTable.data.length > 0" style="width: 55%;padding-left: 20px;">
        <div>{{type}} Attachment</div>
        <div>
          <mat-table [dataSource]="attachmentMatTable" aria-label="Attachment Table" tabindex="-1">
            <ng-container matColumnDef="FileName">
              <mat-header-cell *matHeaderCellDef translate>File Name
              </mat-header-cell>
              <mat-cell *matCellDef="let AR">
                <a style="cursor: pointer" (click)="saveAttachment(AR)">
                  {{AR.FileName}}
                </a>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Description">
              <mat-header-cell *matHeaderCellDef translate>Description
              </mat-header-cell>
              <mat-cell *matCellDef="let AR">{{AR.AttachmentDescription}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="DocumentType">
              <mat-header-cell *matHeaderCellDef translate>File Type</mat-header-cell>
              <mat-cell *matCellDef="let AR">
                {{AR.DocumentType}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="UploadedDate">
              <mat-header-cell *matHeaderCellDef translate>Uploaded Date
              </mat-header-cell>
              <mat-cell *matCellDef="let AR">
                {{AR.AttachmentAddedOn|date:'MM/dd/yy h:mm a'}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Actions">
              <mat-header-cell *matHeaderCellDef translate>Actions
              </mat-header-cell>
              <mat-cell *matCellDef="let AR">
                <a style="font-size:10pt;cursor:pointer;text-decoration:underline;"
                  (click)="deleteAttachmentClick(AR.Id)">Delete</a>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="attachmentColumnsToDisplay" tabindex="-1">
            </mat-header-row>
            <mat-row *matRowDef="let row; let i = index; columns: attachmentColumnsToDisplay" tabindex="0">
            </mat-row>
          </mat-table>
        </div>
      </div>
    </div>
  </div>
</tyl-kendo-pdf-export>

<div #footer class="flex-footer">
  <div class="flex-footer-left">
    <tyl-button *ngIf="calledFromCheckInOut" image="previous arrow.png" label="Previous" (click)="previousClick()"></tyl-button>
    <tyl-button image="Legend.png" label="Legend" (click)="legendClick()"></tyl-button>
    <tyl-button *ngIf="calledAsDialog" image="add.png" label="Add Attachment" (click)="addAttachmentClick()">
    </tyl-button>
    <tyl-button *ngIf="!calledAsDialog" image="calendar text.png" label="Check History"
      (click)="viewHistoryClick()"></tyl-button>
    <tyl-button *ngIf="showSelfCheckButton && !calledAsDialog" image="calendar text.png" label="View Self Check History"
      (click)="viewSelfCheckHistoryClick()"></tyl-button>
    <tyl-button *ngIf="showAbsentNoticesButton && !calledAsDialog" image="calendar text.png" label="Absent Notices"
      (click)="viewAbsentNoticeClick()"></tyl-button>
  </div>
  <div class="flex-footer-middle">

  </div>
  <div class="flex-footer-right">
    <error-prompt [errorList]="errors"></error-prompt>
    <tyl-button *ngIf="!calledAsDialog" image="checkbox multi.png" label="Mass Update" (click)="massUpdateClick()">
    </tyl-button>
    <tyl-button *ngIf="isLastStudent || !calledFromCheckInOut || !reviewAbsentNoticeDialog" image="Save.png" label="Save" (click)="saveClick()"></tyl-button>
    <tyl-button *ngIf="calledFromCheckInOut && !isLastStudent" image="next arrow.png" label="Next" (click)="nextclick()"></tyl-button>
    <tyl-button *ngIf="calledAsDialog" image="Cancel.png" label="Cancel" (click)="cancelClick()"></tyl-button>
    <tyl-button *ngIf="calledAsDialog && reviewAbsentNoticeDialog" image="Save.png" label="Complete" (click)="completeClick()"></tyl-button>
  </div>
</div>